import { AddressDetailsModel } from '../client/client.model';

export class UpdateCompanyDetailsRequestModel {
  name: string;
  showLogoForCustomer: boolean;
  buttonColor: string;
  backgroundColor: string;
  showReferralInvitation: boolean;
  address: AddressDetailsModel;
}
